// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-core-pages-page-template-tsx" + "-" + "e744ec0a2e6d35273c7d" + ".js";
};